import React from "react";
import { useTranslation } from "react-i18next";

import "./tourTooltip.css";

const mergeClassNames = (...classNames) => {
  return classNames.filter(Boolean).join(" ");
};

const TourTooltip = ({
  backProps,
  continuous,
  index,
  primaryProps,
  size,
  step,
  tooltipProps,
  nextLabel,
}) => {
  const { t } = useTranslation();

  const totalSteps = Number.isInteger(size) && size > 0 ? size : 0;
  const isLastStep = totalSteps > 0 && index === totalSteps - 1;
  const resolvedNextLabel = isLastStep ? t("featureTour.gotIt") : nextLabel;

  const tooltipClassName = mergeClassNames(
    tooltipProps?.className,
    "feature-tour-tooltip",
  );
  const backButtonClassName = mergeClassNames(
    backProps?.className,
    "feature-tour-tooltip__button feature-tour-tooltip__button--back",
  );
  const nextButtonClassName = mergeClassNames(
    primaryProps?.className,
    "feature-tour-tooltip__button feature-tour-tooltip__button--next",
  );

  return (
    <div {...tooltipProps} className={tooltipClassName}>
      <div className="feature-tour-tooltip__content">
        {step?.title ? (
          <div className="feature-tour-tooltip__title">{step.title}</div>
        ) : null}
        <div className="feature-tour-tooltip__body">{step?.content}</div>
      </div>

      <div className="feature-tour-tooltip__footer">
        <span className="feature-tour-tooltip__progress">
          {index + 1} of {totalSteps}
        </span>

        <div className="feature-tour-tooltip__actions">
          {index > 0 ? (
            <button {...backProps} className={backButtonClassName}>
              {t("featureTour.prev")}
            </button>
          ) : null}

          {continuous ? (
            <button {...primaryProps} className={nextButtonClassName}>
              {resolvedNextLabel}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default TourTooltip;
